module.exports = __webpack_public_path__ + "static/media/teaser-sommerbilanz.0048b0e9.jpg";